export default __webpack_public_path__ + "static/media/Homepage.5063f55d.svg";